import { render, staticRenderFns } from "./forgetPasswordStep1.vue?vue&type=template&id=23a0b526&scoped=true&"
import script from "./forgetPasswordStep1.vue?vue&type=script&lang=js&"
export * from "./forgetPasswordStep1.vue?vue&type=script&lang=js&"
import style0 from "./forgetPasswordStep1.vue?vue&type=style&index=0&id=23a0b526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a0b526",
  null
  
)

export default component.exports